<template>
  <HeaderMain />
  <router-view></router-view>
  <FooterMain />
</template>

<script>
import HeaderMain from './components/HeaderMain.vue';
import FooterMain from './components/FooterMain.vue';

export default {
  name: 'App',
  components: {
    HeaderMain,
    FooterMain,
  },
};
</script>